const RC = "RC";
const TC = "TCBase";
const TP = "TCPremium";
const TR = "TR";

export { RC, TC, TP, TR };
